import React, { Component } from "react";
import { filter, get, min } from "lodash";
import classNames from "classnames";
import moment from "moment";
import { Link } from "react-router-dom";
import "./Table.scss";
import FontAwesomeIcon from "../Icon";
import { ICONS, PATHS } from "../../common/constants";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchGroupServiceRequest } from "../../store/actions/serviceRequests";
import { clearServiceRequestByGroup } from "../../store/actions/serviceRequestsByGroup";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import Label from "../Label";
import Status from "../Status";
import IcoMoon from "../IcoMoon";

import { serviceRequestTableLocalTime } from "../../helpers/validationHelper";
import Checkbox from "../Checkbox";
import { sortByNumberOrString } from "../Table/sorting";

class GroupingTable extends Component {
  state = {
    accessor: "",
    direction: "",
  };

  filterDay = (data) => {
    const days = moment().diff(moment(data.createdDate), "days");
    const color = days <= 30 ? "teal" : days <= 60 ? "yellow" : "red";
    return (
      <Label
        color={color}
        label={serviceRequestTableLocalTime(data.createdDate)}
      />
    );
  };
  filterSuites = (data) => {
    const {
      user,
      selectedIds,
      onClickBulkUpdate,
      handleDeleteServiceRequestFromGroup,
    } = this.props;
    let selectedObj = selectedIds.find((object) => object.id === data.id);
    let selectedId = selectedObj && selectedObj.id ? selectedObj.id : null;

    return (
      <div style={{ flexDirection: "row", display: "flex" }}>
        {user.roles[0].role.name === "Home Owner" ||
        user.roles[0].role.name === "Vendor" ? null : (
          <>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => handleDeleteServiceRequestFromGroup(data)}
            >
              {" "}
              <FontAwesomeIcon glyph="object-ungroup" weight="regular" size="big" />{" "}
              &nbsp;&nbsp;
            </span>
            <Checkbox
              checked={selectedId === data.id}
              name={selectedId ? selectedId : null}
              value={selectedId ? selectedId : ""}
              onClick={() => onClickBulkUpdate(data.id, data)}
              readOnly
            />
          </>
        )}
        {
          <Link
            to={{
              pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(":id", data.id),
              state: { navigateTo: this.props.navigateTo },
            }}
          >
            <></>
          </Link>
        }
      </div>
    );
  };

  render() {
    const { user, columns, data, from, applyMinWidth } = this.props;

    
    const { accessor, direction } = this.state;
    const sortingAlgorithm = columns.find((c)=> c.accessor === accessor)?.sortingAlgorithm ?? sortByNumberOrString;
    const sorted = accessor
      ? data.slice().sort((a, b) => {
          if (!accessor) return 1;
          const valA = get(a, accessor);
          const valB = get(b, accessor);
          return sortingAlgorithm(valA, valB);
        })
      : data;

    const minWidth = applyMinWidth
      ? columns.reduce((filtered, column) => {
          column.minWidth && filtered.push(column.minWidth);
          return filtered;
        }, [])
      : [];

    const results = direction === "ascending" ? sorted.reverse() : sorted;

    return (
      <table
        className="grouping_table"
        style={{ minWidth: `calc(${minWidth.join(" + ")})` }}
      >
        <thead className="grouping_table__head">
          <tr
            className={classNames("grouping_table__row", {
              grouping_table__row__fixed: true,
            })}
          >
            {columns
              .filter((x) => x)
              .map((c, i) => (
                <th
                  key={i}
                  className={classNames("grouping_table__header", {
                    "grouping_table__header--center": c.center,
                    "grouping_table__header--hide-xs": c.xsHide,
                  })}
                  style={c.style || {}}
                >
                  {c.sortable ? (
                    <button
                      className="grouping_table__sort"
                      onClick={() =>
                        this.setState({
                          accessor: c.accessor,
                          direction:
                            direction === "ascending"
                              ? "descending"
                              : "ascending",
                        })
                      }
                    >
                      {c.label}
                      {c.accessor === accessor && (
                        <FontAwesomeIcon
                          glyph={
                            direction === "ascending"
                              ? "caret-up"
                              : "caret-down"
                          }
                          weight="solid"
                        />
                      )}
                    </button>
                  ) : (
                    c.label
                  )}
                </th>
              ))}
          </tr>
        </thead>
        <tbody className="grouping_table__body">
          {results.map((d, i) => (
            <React.Fragment key={`fgm-${i}`}>
              <tr
                key={`row-${i}`}
                className={
                  this.props.expandedGroups.includes(d.id)
                    ? "grouping_table__row boxshadowRow"
                    : "grouping_table__row"
                }
              >
                {columns
                  .filter((x) => x)
                  .map((c, x) => (
                    <td
                      key={`cell-${x}-${i}`}
                      className={classNames("grouping_table__data", {
                        "grouping_table__data--center": c.center,
                        "grouping_table__data--hide-xs date": c.xsHide,
                      })}
                    >
                      {c.cell ? c.cell(d) : get(d, c.accessor)}
                    </td>
                  ))}
              </tr>
              {this.props.expandedGroups.includes(d.id)
                ? this.props.serviceRequestByGroup[d.id]?.length > 0
                  ? this.props.serviceRequestByGroup[d.id].map((data, idx) => (
                      <tr
                        className="grouping_table__row boxshadowRow"
                        key={`grouped-id-${idx}`}
                      >
                        <td
                          className={classNames("grouping_table__data", {
                            grouping_table__data: true,
                          })}
                        >
                          {this.filterSuites(data)}
                        </td>
                        <td
                          className={classNames("grouping_table__data", {
                            grouping_table__data: true,
                          })}
                        >
                          <Link
                            to={{
                              pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(
                                ":id",
                                data.id
                              ),
                              state: { navigateTo: this.props.navigateTo },
                            }}
                          >
                            {from === "CommonArea" ? (
                              data.commonAreaName
                            ) : data.suiteName ? (
                              <div
                                title={
                                  data.suiteName +
                                  (data.stratalot ? " | " + data.stratalot : "")
                                }
                                className="cut-text"
                              >
                                {data.suiteName +
                                  (data.stratalot
                                    ? " | " + data.stratalot
                                    : "")}
                              </div>
                            ) : data.requestType === "Grouping" ? (
                              data.ticketNumber
                            ) : (
                              "Common Area"
                            )}
                          </Link>
                        </td>
                        <td
                          className={classNames("grouping_table__data", {
                            grouping_table__data: true,
                            "grouping_table__data--hide-xs date": true,
                          })}
                        >
                          {data.commonAreaName
                            ? data.commonAreaName
                            : data.area && data.area.name
                            ? data.area.name
                            : ""}
                        </td>
                        <td
                          className={classNames("grouping_table__data", {
                            grouping_table__data: true,
                            "grouping_table__data--hide-xs date": true,
                          })}
                        >
                          {data.itemName}
                        </td>
                        <td
                          className={classNames("grouping_table__data", {
                            grouping_table__data: true,
                            "grouping_table__data--hide-xs date": true,
                          })}
                        >
                          <div title={data.description}>{data.description}</div>
                        </td>
                        <td
                          className={classNames("grouping_table__data", {
                            grouping_table__data: true,
                            "grouping_table__data--hide-xs date": true,
                          })}
                        >
                          <div
                            title={
                              data.requestType !== "Grouping"
                                ? data.requestType === "CommonArea"
                                  ? "Common"
                                  : data.requestType === null
                                  ? "Warranty"
                                  : data.requestType
                                : ""
                            }
                            className="cut-text"
                          >
                            {data.requestType !== "Grouping"
                              ? data.requestType === "CommonArea"
                                ? "Common"
                                : data.requestType
                              : ""}
                          </div>
                        </td>
                        <td
                          className={classNames("grouping_table__data", {
                            grouping_table__data: true,
                          })}
                        >
                          <Status
                            icon={
                              data.status === "Under Review" ? (
                                <FontAwesomeIcon
                                  glyph="hourglass-end"
                                  weight="light"
                                  size="solid"
                                />
                              ) : data.status === "One Year Warranty" ? (
                                <FontAwesomeIcon
                                  glyph="certificate"
                                  weight="solid"
                                  size="solid"
                                />
                              ) : (
                                <IcoMoon glyph={ICONS[data.status]} />
                              )
                            }
                            label={<div title={data.status}>{data.status}</div>}
                          />
                        </td>
                        <td
                          className={classNames("grouping_table__data", {
                            "grouping_table__data--center": true,
                            "grouping_table__data--hide-xs date": true,
                          })}
                        >
                          {this.filterDay(data)}
                        </td>

                        {user.roles[0].role.name === "Property Developer" ||
                        user.roles[0].role.name === "Strata Manager" ||
                        user.roles[0].role.name === "Service Provider" ||
                        user.roles[0].role.name === "Service Manager" ? (
                          <>
                            <td
                              className={classNames("grouping_table__data", {
                                grouping_table__data: true,
                                "grouping_table__data--hide-xs date": true,
                              })}
                            >
                              {data.estimatedTime}
                            </td>
                            <td
                              className={classNames("grouping_table__data", {
                                grouping_table__data: true,
                                "grouping_table__data--hide-xs date": true,
                              })}
                            >
                              {data.actualTime}
                            </td>
                          </>
                        ) : null}
                      </tr>
                    ))
                  : null
                : null}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceRequestByGroup: state.serviceRequestsByGroup.serviceRequestByGroup,
  user: selectAuthenticatedUser(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchGroupServiceRequest: fetchGroupServiceRequest,
      clearServiceRequestByGroup: clearServiceRequestByGroup,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(GroupingTable);
